module.exports = __webpack_public_path__ + "static/media/no-results.2efc579d.svg";